import React, { useState } from 'react';

import { DropboxDocumentEntity, MSUnifiedEntity } from 'jamespot-user-api';

import { useIntl } from 'react-intl';

import styled from 'styled-components';

import { EntityItemSelection } from './EntityItemSelection';
import { EntityItemTitle } from './EntityItemTitle';
import { EntityAvatar } from './EntityAvatar';
import { JRCTooltip } from '../../JRCTooltip/JRCTooltip';
import { JRCIcon } from '../../JRCIcon/JRCIcon';

export const CSSEntity = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
    cursor: pointer;

    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }
`;

export const CSSEntityAvatar = styled.div`
    position: relative;
`;

export const CSSEntityAvatarHover = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
`;

export const EntityItem = <T extends MSUnifiedEntity | DropboxDocumentEntity>({
    entity,
    initialFolderColor,
    useNavigation = true,
    onSelect,
    onSelectDocument,
    onSelectMultiDocument,
    onClick,
}: {
    entity: T;
    initialFolderColor?: string;
    useNavigation: boolean;
    onSelect?: (entity: T) => void;
    onSelectDocument?: (entity: T) => void;
    onSelectMultiDocument?: (entity: T) => void;
    onClick: () => void;
}) => {
    const intl = useIntl();
    const [hasSelection, setHasSelection] = useState<boolean>(false);

    return (
        <CSSEntity>
            <CSSEntityAvatar>
                <EntityAvatar
                    type={entity.type}
                    mimetype={entity.mimetype ?? undefined}
                    initialFolderColor={initialFolderColor}
                />
                <CSSEntityAvatarHover>
                    {'visibility' in entity && entity.visibility === 'private' ? (
                        <JRCTooltip description={intl.formatMessage({ id: 'DRIVE_Private_Group' })}>
                            <JRCIcon name="icon-lock" color={'#fff'} size={12} />
                        </JRCTooltip>
                    ) : (
                        <></>
                    )}
                </CSSEntityAvatarHover>
            </CSSEntityAvatar>
            <EntityItemTitle
                title={entity.title}
                type={entity.type}
                url={entity.webUrl}
                useNavigation={useNavigation}
                onClick={onClick}
            />
            {onSelect && ['folder', 'group'].includes(entity.type) ? (
                <EntityItemSelection
                    title={intl.formatMessage({ id: 'DRIVE_Select_Folder' })}
                    onClick={() => onSelect(entity)}
                />
            ) : (
                <></>
            )}
            {onSelectDocument && ['document'].includes(entity.type) && !hasSelection ? (
                <EntityItemSelection
                    title={intl.formatMessage({ id: 'DRIVE_Select_Document' })}
                    onClick={(isSelected) => {
                        setHasSelection(isSelected);
                        onSelectDocument(entity);
                    }}
                />
            ) : (
                <></>
            )}
            {onSelectMultiDocument && ['document'].includes(entity.type) && !hasSelection ? (
                <EntityItemSelection
                    title={intl.formatMessage({ id: 'DRIVE_Select_Document' })}
                    onClick={() => onSelectMultiDocument(entity)}
                />
            ) : (
                <></>
            )}
        </CSSEntity>
    );
};
